import axios from "axios";

// The tenant this app runs under has been merged into another one. Laravel's MultiTenant middleware
// answers a navigation with a 301, but an XHR cannot be: the browser would follow it to the successor's
// origin and CORS would end the call there. So the API answers this instead, and names the page to leave.
const TENANT_MERGED = 492;

export default defineNuxtPlugin((nuxtApp) => {
    let api = axios.create({
        baseUrl: "//" + window.location.host,
        headers: {
            common: {}
        }
    });

    api.interceptors.response.use(
        response => response,
        error => {
            const target = error.response?.status === TENANT_MERGED ? error.response.data?.url : null;

            if (!target) return Promise.reject(error);

            window.location.replace(target);

            // Deliberately never settles. The page is being replaced, and a rejection here would let the
            // caller render its error state in the moment before that happens.
            return new Promise(() => {});
        }
    );

    nuxtApp.vueApp.provide('axios', api);

    return {
        provide: {
            axios: api
        }
    };
});